<template>
  <div id="contenedor-main-listado">
    <template
      v-if="!$vuetify.breakpoint.mobile">
      <desktop :usuarios="usuarios"></desktop>
    </template>
    <template
      v-else>
      <desktop :usuarios="usuarios"></desktop>
    </template>
  </div>
</template>

<script>
import Desktop from './Desktop.vue';
// import Mobile from './Mobile.vue';

export default {
  name: 'MainListado',
  props: {
    usuarios: {
      type: Array,
      required: true,
    },
  },
  components: {
    Desktop,
    // Mobile,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
